import { Card } from "react-bootstrap";

export const NetworkMonitoringNotice = () => {
  return (
    <Card className="h-24 p-2 bg-info text-white rounded-md">
      Notice: Network Monitoring is temporarily limited due to internal changes.
      Normal functionality will be restored shortly.
    </Card>
  );
};
